import React from 'react';
import Chip from '@mui/material/Chip';
import Rating from '@mui/material/Rating';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useT, type TextKey } from '../../i18n';
import { LEVEL_COLOR, formatScore, levelOf } from './ratingLevel';

/**
 * Calificación del cliente: estrellas, número y nivel («★★★★☆ 4,2 Bueno»). En `compact` muestra solo las
 * estrellas y el número (para tablas).
 */
interface RatingStarsProps {
  score: number | null | undefined;
  compact?: boolean;
  size?: 'small' | 'medium' | 'large';
}

const RatingStars: React.FC<RatingStarsProps> = ({ score, compact = false, size = 'small' }) => {
  const t = useT();
  const level = levelOf(score);
  if (level === 'none') {
    return (
      <Typography variant="body2" color="text.secondary" component="span">
        {t('rating.level.none')}
      </Typography>
    );
  }
  const label = `${formatScore(score)} · ${t(`rating.level.${level}` as TextKey)}`;
  return (
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ minWidth: 0, flexWrap: 'wrap', rowGap: 0.5 }} aria-label={`${t('rating.score')}: ${label}`}>
      <Rating value={Number(score)} precision={0.1} readOnly size={size} sx={{ flexShrink: 0 }} />
      <Typography variant="body2" component="span" sx={{ fontWeight: 700 }}>
        {formatScore(score)}
      </Typography>
      {!compact && <Chip size="small" color={LEVEL_COLOR[level]} label={t(`rating.level.${level}` as TextKey)} sx={{ height: 22 }} />}
    </Stack>
  );
};

export default RatingStars;
